import Modal from 'developer_components/newModal';
import NotificationStep from './steps/notification-step';

export const GOOGLE_MAIL_BLOCKED_TITLE = 'Регистрация через Google в России недоступна';

export const GOOGLE_MAIL_BLOCKED_MESSAGE =
    'На ПриветТур нельзя зарегистрироваться из России через иностранные сервисы — это новые требования законодательства. Используйте другой способ.';

export const GOOGLE_MAIL_BLOCKED_TYPE = 'google_registration_blocked';

export function isGoogleMail(email) {
    return /@(?:gmail|googlemail)\.com$/i.test(String(email).trim());
}

export function isGoogleRegistrationBlockedResponse(response) {
    return response?.type === GOOGLE_MAIL_BLOCKED_TYPE;
}

export function showGoogleMailBlockedModal(modal) {
    const step = new NotificationStep(modal, {
        title: GOOGLE_MAIL_BLOCKED_TITLE,
        description: GOOGLE_MAIL_BLOCKED_MESSAGE,
    });

    step.canPrevStep = true;
    modal.showStep(step);
}

let legacyPopupInstance = null;

export function showGoogleMailBlockedLegacyModal() {
    if (!legacyPopupInstance) {
        const $element = Modal.createFromHTML(
            `<div class="Message-modal container">
                <div class="background"></div>
                <div class="form">
                    <div class="form-header">
                        <div class="mobile-wrapper">
                            <div class="logo"></div>
                            <button class="close-button js-modalClose"></button>
                        </div>
                        <div class="cross-wrapper"><div class="cross js-modalClose"></div></div>
                    </div>
                    <div class="form-content">
                        <div class="header-title">${GOOGLE_MAIL_BLOCKED_TITLE}</div>
                        <div class="message">${GOOGLE_MAIL_BLOCKED_MESSAGE}</div>
                    </div>
                    <div class="form-footer">
                        <span class="link js-modalClose">Понятно</span>
                    </div>
                </div>
            </div>`,
            {
                id: 'google-mail-blocked',
            },
        );

        legacyPopupInstance = new Modal($element, {
            modal_id: 'google-mail-blocked',
        });
    }

    legacyPopupInstance.open();
}

export function bindGoogleRegistrationBlockedPopupHandler() {
    window.popup_google_registration_blocked = function() {
        if (window.popup) {
            window.popup.close();
        }

        showGoogleMailBlockedLegacyModal();
    };
}
